'use client'

import { useEffect, useState } from 'react';
import { loadGtm, GTM_ID } from '../../../lib/gtm';
import usePageView from '../../../hooks/usePageView';
import { useConsent } from '../../../providers/ConsentProvider';

export default function Gtm() {
  const { consentGiven } = useConsent();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // GTM n'est chargé qu'après consentement
    if (!GTM_ID || !consentGiven) return;

    loadGtm();
    setLoaded(true);
  }, [consentGiven]);

  if (!loaded || !consentGiven) return null;

  return <PageView />;
};

function PageView() {
  usePageView();

  return null;
}
